import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { addLPNToWantedFailed, addLPNToWantedSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* addLPNToWanted(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/wanted-list`;
    const dataResponse = yield makeRequest(url, { license_plate: action.payload }, action, 'POST', true);
    if (dataResponse.status === OK) {
      yield put(addLPNToWantedSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield dataResponse.json();
      yield put(addLPNToWantedFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(addLPNToWantedFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
